
































import { Vue, Component, Prop, Emit, Ref } from 'vue-property-decorator';
import * as I from '@/interfaces';
import * as E from '@/enums';
@Component
export default class AxMonitorContext extends Vue {
  @Ref()
  context!: HTMLElement;

  isVisible = false;
  x = 0;
  y = 0;
  doorid = 0;
  controlCode = 0;

  listControl: I.SelectData[] = [
    { icon: '1', text: '개방' },
    { icon: '2', text: '한번개방' },
    { icon: '3', text: '패쇄' },
    { icon: '4', text: '초기화' },
    { icon: '5', text: '스케즐 시작' },
    { icon: '6', text: '스케즐 정지' }
  ];

  Show(e: MouseEvent, id: number) {
    this.isVisible = true;
    this.$nextTick(() => {
      let x = e.clientX;
      let y = e.clientY;
      const winWidth = window.innerWidth; //윈도우 넓이
      const winHeight = window.innerHeight; //윈도우 높이

      this.doorid = id;
      console.log('log:' + this.doorid);

      if (this.context) {
        const width = this.context.clientWidth; //컨텍스트 넓이
        const height = this.context.clientHeight; //컨텍스트 높이
        if (x + width > winWidth) {
          //컨텍스트가 화면 우측으로 나갈 경우
          x -= width;
        }
        if (y + height > winHeight) {
          //컨텍스트가 화면 아래로 내려갈 경우
          y -= height;
        }
        this.x = x;
        this.y = y;
      }
      // this.$el.focus();
    });
  }
  Open(idx: number) {
    console.log('open:' + idx);
    if (idx === 0) {
      this.controlCode = E.EControlCode.PORT_OPEN;
    } else if (idx === 1) {
      this.controlCode = E.EControlCode.PORT_OPEN_ONCE;
    } else if (idx === 2) {
      this.controlCode = E.EControlCode.PORT_CLOSE;
    } else if (idx === 3) {
      this.controlCode = E.EControlCode.PORT_INITIATE;
    } else if (idx === 4) {
      this.controlCode = E.EControlCode.RESUME_TIME_SCHEDULE;
    } else if (idx === 5) {
      this.controlCode = E.EControlCode.SUSPEND_TIME_SCHEDULE;
    }

    this.$emit('openClick', this.doorid, this.controlCode);
    console.log('parant' + this.$parent);
    this.isVisible = false;
  }
  Hide(e: Event) {
    this.isVisible = false;
  }
  FocusOut(e: Event) {
    this.Hide(e);
  }
}
